export default __webpack_public_path__ + "static/media/640_dummy2016-anwaltskanzlei01-de.1278a9e0.png";